import { render, staticRenderFns } from "./ContentImage.vue?vue&type=template&id=bca87af2&"
import script from "./ContentImage.vue?vue&type=script&lang=ts&"
export * from "./ContentImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports